const CONFIG = {
  domain_url: 'https://prd-dcinnovation-chat-assistant-api.azure-api.net/',
};

export default CONFIG;